/**
 * Determina si un error de Axios es un error de red/CORS.
 * @param {Error} error - Error capturado en un catch
 * @returns {boolean}
 */
export const isNetworkError = (error) =>
  !error?.response &&
  (error?.message === "Network Error" ||
    error?.code === "ERR_NETWORK" ||
    error?.code === "ERR_BLOCKED_BY_CLIENT");
